export type UtilityBillExtractionMessageKey =
  | 'api_error'
  | 'bad_bill'
  | 'expired_utility_bill'
  | 'invalid_utility_bill_date'
  | 'missing_required_data'
  | 'needs_review'
  | 'unsupported_document'
  | 'utility_bill_name_mismatch'
  | 'utility_bill_page_mismatch'
  | 'utility_bill_utility_mismatch'
  | 'utility_bill_valid';

const extractionMessages = new Map<UtilityBillExtractionMessageKey, string>([
  [
    'api_error',
    'We could not validate this utility bill right now. Please enter your utility account details manually to continue.',
  ],
  [
    'bad_bill',
    'We could not validate this utility bill. Please ensure you upload all pages of your latest utility bill and try again.',
  ],
  [
    'expired_utility_bill',
    'Your utility bill is more than 90 days old. Please upload a utility bill dated within the last 90 days to continue.',
  ],
  [
    'invalid_utility_bill_date',
    'We could not verify the bill date. Please upload a utility bill with a clearly visible statement date from the last 90 days to continue.',
  ],
  [
    'missing_required_data',
    'Required utility bill fields were not found. Please ensure you upload all pages of your latest utility bill.',
  ],
  [
    'needs_review',
    'Some bill details need review. Please confirm the pre-filled fields before continuing.',
  ],
  [
    'unsupported_document',
    'This does not look like a supported utility bill. Please upload all pages of your latest utility bill.',
  ],
  ['utility_bill_name_mismatch', 'Name on utility bill does not match.'],
  [
    'utility_bill_page_mismatch',
    'Uploaded bill pages do not appear to match. Please upload pages from the same utility bill.',
  ],
  ['utility_bill_utility_mismatch', 'Utility on bill does not match.'],
  ['utility_bill_valid', 'Utility bill is valid.'],
]);

const isUtilityBillExtractionMessageKey = (key: string): key is UtilityBillExtractionMessageKey =>
  extractionMessages.has(key as UtilityBillExtractionMessageKey);

export const getUtilityBillExtractionMessage = (key: string): string => {
  const normalizedKey = isUtilityBillExtractionMessageKey(key) ? key : 'needs_review';
  return extractionMessages.get(normalizedKey)!;
};

export const getUtilityBillExtractionMessages = (keys: readonly string[]): string[] =>
  keys.map(key => getUtilityBillExtractionMessage(key));
